import { apiFetch } from '@/api/client';
import type { User } from '@/types';

export const auth = {
  me: () => apiFetch<User>('/auth/me'),
  logout: () =>
    apiFetch<void>('/auth/logout', {
      method: 'POST',
    }),
  loginUrl: '/api/auth/login',
};
